const quoteTypeVariant = ["multiSiteQuote", "singleSiteQuote"] as const;
export default quoteTypeVariant;
